import { put, select, takeLatest, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import apiAuthCall from 'helpers/apiAuthCall';

import { actions, semKeywordSummaryFetched, semCampaignSummaryFetched, semConversionSummaryFetched, semAdgroupSummaryFetched } from './duck';
import { semKeywordSummaryEndpoint, semCampaignSummaryEndpoint, semConversionSummaryEndpoint, semAdgroupSummaryEndpoint } from './selectors';

export function* fetchSemKeywordSummary(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(semKeywordSummaryEndpoint, action.payload)
            }
        );

        yield put(semKeywordSummaryFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchSemAdgroupSummary(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(semAdgroupSummaryEndpoint, action.payload)
            }
        );

        yield put(semAdgroupSummaryFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchSemCampaignSummary(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(semCampaignSummaryEndpoint, action.payload)
            }
        );

        yield put(semCampaignSummaryFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchSemConversionSummary(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(semConversionSummaryEndpoint, action.payload)
            }
        );

        yield put(semConversionSummaryFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export default function* semSaga({ api }) {
    yield all([
        takeLatest(actions.FETCH_CAMPAIGN_SUMMARY, fetchSemCampaignSummary, api),
        takeLatest(actions.FETCH_CONVERSION_SUMMARY, fetchSemConversionSummary, api),
        takeLatest(actions.FETCH_KEYWORD_SUMMARY, fetchSemKeywordSummary, api),
        takeLatest(actions.FETCH_ADGROUP_SUMMARY, fetchSemAdgroupSummary, api)
    ]);
}



// WEBPACK FOOTER //
// ./src/services/sem/saga.js